import { PortalUtils } from '@powerduck/common/utils/utils';
import { AppConfig } from './app-config';
import { AppRouter } from './app/router';
import AppAgnosticFactory from './app/app-agnostic-factory';
import { AppState } from './app-state';
import { TemporalPolyfillInstaller } from './common/temporal-polyfill-installer'

// PowerDuck FormItemWrapper.ensureTooltip() calls jQuery's Bootstrap tooltip
// plugin (target.tooltip()). Bootstrap JS isn't bundled on every page, so the
// call throws "target.tooltip is not a function" and breaks the wizard render.
// Polyfill the plugin as a no-op when missing — the underlying <i> still has
// title="..." so the browser shows a native tooltip on hover.
(() => {
    const $any = (window as any).$ || (window as any).jQuery;
    if ($any && $any.fn && typeof $any.fn.tooltip !== 'function') {
        $any.fn.tooltip = function () { return this; };
    }
})();

TemporalPolyfillInstaller.install().then(() => {
	AppAgnosticFactory.create().then((appData) => {
		const { app } = appData;
		const initApp = () => {
			// catch(): mount even if the initial navigation was aborted by the auth guard (isReady rejects).
			AppRouter.currentRouter.isReady().catch(() => { }).then(() => {
				AppState._vueInstance = app.mount('#app');

				if (PortalUtils.treatAsMobileDevice()) {
					document.querySelectorAll<HTMLElement>('.mobileLoader').forEach((el) => {
						el.classList.add('mobileLoaderActive');
						el.innerHTML = AppConfig.blockerHtml;
					});
				}
			});
		};

		if ((window as any).appAutoInit == false) {
			(window as any).initApp = initApp;
		} else {
			initApp();
		}
	});
})
